import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { QueryParamService } from '../../../services/query-param.service';
import { EnvironmentService } from '../../../services/environment.service';
import { DomainService } from '../../../services/domain.service';

@Component({
  selector: 'app-footer',
  imports: [NgTemplateOutlet, TranslocoPipe],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  translateService = inject(TranslocoService);
  redirectDomain$$ = inject(DomainService).redirectDomain$$;
  language = this.translateService.getActiveLang();
  currentYear = new Date().getFullYear();
}
